import {DialogManager} from '@modifi/plugin-dialogs'

import TransportDocumentUploadDialog, {
  DIALOG_NAME as TRANSPORT_DOCUMENT_UPLOAD_DIALOG,
} from './transport-document-upload'
import SuccessDialog, {DIALOG_NAME as SUCCESS_DIALOG} from './success-dialog'
import LimitConfirmationDialog, {
  DIALOG_NAME as LIMIT_CONFIRMATION_DIALOG,
} from './limit-confirmation-dialog'
import BuyerSearchDialog, {DIALOG_NAME as BUYER_SEARCH_DIALOG} from './buyer-search-dialog'

DialogManager.addDialog(TRANSPORT_DOCUMENT_UPLOAD_DIALOG, TransportDocumentUploadDialog)
DialogManager.addDialog(SUCCESS_DIALOG, SuccessDialog)
DialogManager.addDialog(LIMIT_CONFIRMATION_DIALOG, LimitConfirmationDialog)
DialogManager.addDialog(BUYER_SEARCH_DIALOG, BuyerSearchDialog)

export {
  TRANSPORT_DOCUMENT_UPLOAD_DIALOG,
  SUCCESS_DIALOG,
  LIMIT_CONFIRMATION_DIALOG,
  BUYER_SEARCH_DIALOG,
}
